import {
    DISABLE_MFA,
    DISABLE_MFA_ERROR,
    DISABLE_MFA_SUCCESS,
    ENABLE_MFA,
    ENABLE_MFA_ERROR,
    ENABLE_MFA_SUCCESS,
    INIT_MFA
} from "./actionTypes";

export const initMfa = () => {
    return {
        type: INIT_MFA,
        payload: {}
    };
};

export const userEnableMfa = (req, history) => {
    return {
        type: ENABLE_MFA,
        payload: {req, history}
    };
};

export const userEnableMfaSuccess = () => {
    return {
        type: ENABLE_MFA_SUCCESS,
        payload: {}
    };
};

export const userEnableMfaError = (error) => {
    return {
        type: ENABLE_MFA_ERROR,
        payload: error
    };
};

export const userDisableMfa = (req, history, callback) => {
    return {
        type: DISABLE_MFA,
        payload: {req, history, callback}
    };
};

export const userDisableMfaSuccess = () => {
    return {
        type: DISABLE_MFA_SUCCESS,
        payload: {}
    };
};

export const userDisableMfaError = (error) => {
    return {
        type: DISABLE_MFA_ERROR,
        payload: error
    };
};
